export default "__VITE_PUBLIC_ASSET__74fda77e__"